import * as ColorsByClient from './colors_by_client';
import colorsDefault from './default.colors';
import Utils from '../lib/Utils';

let colorPallete = { ...colorsDefault, ...ColorsByClient[Utils.getClientName()] }

let colors = {
  ...colorPallete,

  status_done: colorPallete.peace_dark,
  status_running: colorPallete.warning_dark,
  status_enqueue: colorPallete.dark,
  status_failed: colorPallete.red,

  header_menu: colorPallete.gray,
  header_menu_over: colorPallete.light,

  header_table: colorPallete.heather,

  button_hover: '#dcdfe7',

  header_background: colorPallete.dark,
  footer_background: colorPallete.dark,

  check_button_border: colorPallete.light_gray,
  selectable_table_row_border: colorPallete.light_gray,

  side_menu_text: colorPallete.dark,
  side_menu_disabled: '#a8b0bf',
  side_menu_background: '#f5f5f8',
  side_menu_primary: '#F5F5F8',
  side_menu_secondary: '#c7ccd9',
  side_menu_hover: '#97a0b0',
  side_menu_selected: colorPallete.primary + '23',
  side_submenu_hover: '#bec2d1',
  side_item_hover: colorPallete.gray,

  form_items_border: '#868fa2',

  list_header: '#c7cbd9',

  multi_combobox_item: '#dbdce9',

  line_separator_eerr: '#878f96',

  disabled_button: '#ccc',
  disabled_button_text: '#666',

  text_input_modal: '#6D7074',
  background_combobox_input: '#F5F5F8',

  placeholder: '#818181',

  black: '#000000',
  icon: colorPallete.mirage,

  heatmapDisabledColors: [['#fff']],
  heatmapArray: ['#ff9999', '#ffa399', '#ffad99', '#ffb799', '#ffb399', '#ffcd99', '#ffd799', '#ffe199', '#ffe599', '#fff199', '#ffff99', '#e5ff99', '#d8ff99', '#ccff99', '#bfff99', '#b3ff99', '#99ff99', '#8cff99', '#80ff99', '#73ff99', '#66ff99'],
  lineChartsArray: [colorPallete.primary, '#663629', '#EAB3A4', '#E67A5C', '#664E47', '#B86149'],
  barChartsArray: [colorPallete.primary, Utils.darken(colorPallete.primary, 30)],
  assetExcelFile: ['ABA9A9', 'CCCBCB', 'E5E5E5'],

  first_waterfall: '#005c7f',
  last_waterfall: '#010001',
  last_waterfall_mkt_chart: '#5a5a5a',
  positive_waterfall: '#439647',
  negative_waterfall: '#de6a56'
}

export default colors
